import React from 'react';

import QuestionText from './QuestionText';
import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import classNames from 'classnames';

export default function InputTextQuestion({
  question,
  onChange,
  model,
  submitted,
  shouldDisabled,
}) {
  function renderText() {
    return <QuestionText question={question} />;
  }

  function renderInput() {
    const value = model[question.variable] || '';

    return (
      <input
        type="text"
        className="form-control px-0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        autoFocus={question.autoFocus}
        disabled={shouldDisabled ? shouldDisabled(question) : false}
      />
    );
  }

  const renderFloatingInput = () => {
    const value = model[question.variable] || '';

    return (
      <FloatingInput
        labelName={question.text}
        placeholder={question.placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={question.autoFocus}
        disabled={shouldDisabled ? shouldDisabled(question) : false}
      />
    );
  };

  const renderControl = () => {
    if (question.floatingInput) {
      return renderFloatingInput();
    } else {
      return (
        <>
          {renderText()}
          {renderInput()}
        </>
      );
    }
  };

  function renderValidationMessage() {
    if (!submitted || !question.validationMessage) {
      return null;
    }

    const value = model[question.variable] || '';

    if (question.minLength && value.length >= question.minLength) {
      return null;
    }

    if (question.required && value) {
      return null;
    }

    return (
      <div className="av-red mt-1 font-size-12">
        {question.validationMessage}
      </div>
    );
  }

  const containerClassName = classNames('question input-text-question', {
    disabled: shouldDisabled ? shouldDisabled(question) : false,
  });
  return (
    <div className={containerClassName}>
      {renderControl()}
      {renderValidationMessage()}
    </div>
  );
}
